const lastSesionStatusText = ['Scheduled', 'Overdue', 'Complete', 'Incomplete', 'Incomplete', 'No Sessions Due', 'Due Today']

export default lastSesionStatusText
